import { PageController } from '@client/components/_core/layout/PageController';
import { IncidentLodgementFormConfiguration } from '@client/components/incidents/IncidentLodgementFormConfiguration';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2 } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general/lodgement')({
    staticData: {
        metadata: {
            title: 'Lodgement form',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: IncidentLodgement,
});

function IncidentLodgement() {
    return (
        <PageController route={Route}>
            <IncidentLodgementFormConfiguration />
        </PageController>
    );
}
